import { useIsMobileScreenSize } from './useIsMobileScreenSize';
import { useIsHoverable } from './useMediaQuery';

export const useIsMobile = () => {
  const isMobileScreenSize = useIsMobileScreenSize();
  const isHoveringSupported = useIsHoverable();

  return isMobileScreenSize || !isHoveringSupported;
};
